import { OPEN, CLOSE } from "./types";

export const openPanel = (data = {}) => {
	return {
		...data,
		type: OPEN,
	};
};

export const closePanel = (data = {}) => {
	return {
		...data,
		type: CLOSE,
	};
};
